/**
* VisitEntity Interface
*
* Generated file, don't touch manually
*
* ModelVersion: 90001
*/

export { VisitEntity } from "@archipad-js/archipad-model";
